import React from "react";
import { StyledSelect } from "./StyledSelect";
import { useCityList } from "../../hooks/useCityList";
import { Loader } from "@swiggy-private/dls-web-core/dist/components/Loader";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

interface CitySelectProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    label?: string;
    disabled?: boolean;
    error?: boolean;
    errorMessage?: string;
}

export const CitySelect: React.FC<CitySelectProps> = ({
    value,
    onChange,
    placeholder = "Select City",
    label,
    disabled = false,
    error = false,
    errorMessage
}) => {
    const { cities, isLoading, error: apiError } = useCityList();

    // Convert API cities to select options
    const cityOptions = cities.map(city => ({
        value: city.city_id.toString(),
        label: city.city_name
    }));

    if (isLoading) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Loader size="small" type="primary" />
                <Text variant="V2.body2.neutral.regular" color="text_Med_Emphasis">
                    Loading cities...
                </Text>
            </div>
        );
    }

    if (apiError) {
        return (
            <div>
                <Text variant="V2.body2.neutral.regular" color="negative">
                    Failed to load cities. Please try again.
                </Text>
            </div>
        );
    }

    return (
        <StyledSelect
            value={value}
            onChange={onChange}
            options={cityOptions}
            placeholder={placeholder}
            label={label}
            disabled={disabled}
            error={error}
            errorMessage={errorMessage}
            floatingLabel={true}
        />
    );
};
